export default __webpack_public_path__ + "static/media/ALC-CIRCLE.b68112d7.png";